export const withApprovalButton = (WrappedComponent) => {
  return (props) => {
    const { approveButtonState } = props;
    if (approveButtonState?.showButton) {
      return <WrappedComponent {...props} />;
    }
    return null;
  };
};
